// extracted by mini-css-extract-plugin
module.exports = {"customBackground":"TrackingFinanceDetailsComponent-module__customBackground","blueBackground":"TrackingFinanceDetailsComponent-module__blueBackground"};